/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Force_Unlock_TitleInputs */



/**
* | output |
* | --- |
* | "Force-Unlock Tournament?" |
*
* @param {Offline_Force_Unlock_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const offline_force_unlock_title = /** @type {((inputs?: Offline_Force_Unlock_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Force_Unlock_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Forcer le déverrouillage du tournoi ?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Forzar desbloqueo del torneo?")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Forçar desbloqueio do torneio?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Forzare lo sblocco del torneo?")
	return /** @type {LocalizedString} */ ("Force-Unlock Tournament?")
});